import { useWorkspacesList } from "@api/workspace.api";
import { Entity } from "@common/types/entity";
import { useCanUseConsolidation } from "@hooks/useCanUseConsolidation";
import { useEntities } from "@hooks/useEntities";
import { getActionsTasksAccountsNavPaths } from "../getActionsTasksAccountsNavPaths";

interface NavigationData {
    navDisplayConfig: ReturnType<typeof getActionsTasksAccountsNavPaths>;
    businessEntities: Entity[];
    hasBusinessEntities: boolean;
    hasMultipleWorkspaces: boolean;
    canUseConsolidation: boolean;
}

export function useNavigationData(): NavigationData {
    const canUseConsolidation = useCanUseConsolidation();

    const navDisplayConfig = getActionsTasksAccountsNavPaths();
    const workspacesQuery = useWorkspacesList();

    const businessEntities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });

    const hasBusinessEntities = businessEntities.length > 0;
    const hasMultipleWorkspaces = (workspacesQuery.data?.length ?? 0) > 1;

    return {
        navDisplayConfig,
        businessEntities,
        hasBusinessEntities,
        hasMultipleWorkspaces,
        canUseConsolidation,
    };
}
